import { Link } from "react-router-dom";
import { Scale, Mail, Globe, MapPin, AlertTriangle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-black" data-testid="site-footer">
      {/* Not a law firm disclaimer */}
      <div className="border-b border-zinc-800 bg-amber-950/30">
        <div className="container-pl py-5">
          <div className="flex items-start gap-3 max-w-5xl mx-auto" data-testid="footer-disclaimer">
            <AlertTriangle className="h-4 w-4 text-amber-400 flex-shrink-0 mt-0.5" strokeWidth={1.75} />
            <p className="text-xs text-zinc-200 leading-relaxed">
              <span className="font-semibold text-zinc-50">We are not a law firm.</span>{" "}
              Paralegal Voices of New York provides paralegal services only. We do not provide legal
              advice or represent clients in court. For legal advice, consult a licensed attorney.
            </p>
          </div>
        </div>
      </div>

      <div className="container-pl py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <Scale className="h-5 w-5 text-amber-400" strokeWidth={1.5} />
              <div className="leading-tight">
                <p className="display-serif text-base text-zinc-50">Paralegal Voices</p>
                <p className="text-[10px] tracking-[0.22em] uppercase text-amber-400 font-semibold">of New York</p>
              </div>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Professional paralegal support for the moments that matter most.
            </p>
            <p className="quote-serif text-sm text-amber-400 mt-5">"Pain births purpose."</p>
            <p className="text-xs text-zinc-500 mt-5">
              Founded by <span className="text-zinc-200 font-medium">Darrell Graham</span>
            </p>
          </div>

          <div>
            <h4 className="overline mb-5">Services</h4>
            <ul className="space-y-2.5 text-sm text-zinc-300">
              <li><Link to="/incarcerated" className="hover:text-amber-400 link-underline">Incarcerated</Link></li>
              <li><Link to="/families" className="hover:text-amber-400 link-underline">Families</Link></li>
              <li><Link to="/defense" className="hover:text-amber-400 link-underline">Defense</Link></li>
              <li><Link to="/hearings" className="hover:text-amber-400 link-underline">Hearings</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="overline mb-5">Firm</h4>
            <ul className="space-y-2.5 text-sm text-zinc-300">
              <li><Link to="/about" className="hover:text-amber-400 link-underline">About Darrell</Link></li>
              <li><Link to="/community" className="hover:text-amber-400 link-underline">Community Forum</Link></li>
              <li><Link to="/faq" className="hover:text-amber-400 link-underline">FAQ</Link></li>
              <li><Link to="/booking" className="hover:text-amber-400 link-underline">Schedule</Link></li>
              <li><Link to="/login" className="hover:text-amber-400 link-underline font-medium text-amber-400" data-testid="footer-client-login">Client Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="overline mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li className="flex items-start gap-2.5">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0 text-amber-400" strokeWidth={1.5} />
                <a href="mailto:Darrell@paralegalvoicesofnewyork.com" className="hover:text-amber-400 link-underline break-all" data-testid="footer-email">
                  Darrell@paralegalvoicesofnewyork.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Globe className="h-4 w-4 mt-0.5 flex-shrink-0 text-amber-400" strokeWidth={1.5} />
                <a href="https://paralegalvoicesofnewyork.com" target="_blank" rel="noreferrer" className="hover:text-amber-400 link-underline" data-testid="footer-website">
                  paralegalvoicesofnewyork.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-amber-400" strokeWidth={1.5} />
                <span>By appointment only · New York</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-400">
          <p>© {new Date().getFullYear()} Paralegal Voices of New York. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-amber-400 link-underline" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-amber-400 link-underline" data-testid="footer-terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
